import { SinisterFollowUpService } from "../../../shared/services/api/sinister/SinisterFollowUpService";
import { SinisterInternalFollowUpService } from "../../../shared/services/api/sinister/SinisterInternalFollowUpService";
import { trackAsync } from "../../../shared/utils/telemetry";

interface GenerateFollowUpsParams {
	sinisterId: string;
	note: string;
	generateInternal: boolean;
	generateExternal: boolean;
	// Identifica a origem no telemetry (ex: "update_case_status", "change_sector") — cada modal do
	// módulo de cobrança passa o seu.
	trackLabel: string;
}

// Dispara os dois follow-ups (interno/externo) de um lançamento do módulo de cobrança — Status,
// Ações, Responsável, Setor e Etapa usam o mesmo par de checkboxes e a mesma lógica de disparo.
// Ambos são ações secundárias: se falharem, não devem derrubar o sucesso da ação principal (que já
// foi salva antes desta função ser chamada).
export const generateFollowUps = async ({ sinisterId, note, generateInternal, generateExternal, trackLabel }: GenerateFollowUpsParams): Promise<void> => {
	if (generateInternal) {
		try {
			await trackAsync(
				`followup.internal_note.${trackLabel}`,
				() => SinisterInternalFollowUpService.addSinisterInternalFollowupNote(sinisterId, note),
				{ sinisterId }
			);
		} catch (error) {
			console.error(`Falha ao gerar follow-up interno automático (${trackLabel}):`, error);
		}
	}

	if (generateExternal) {
		try {
			await trackAsync(`followup.external_note.${trackLabel}`, () => SinisterFollowUpService.addSinisterFollowupNote(sinisterId, note), {
				sinisterId,
			});
		} catch (error) {
			console.error(`Falha ao gerar follow-up externo automático (${trackLabel}):`, error);
		}
	}
};
